export default __webpack_public_path__ + "static/media/user_activity_65.e507594d.png";